<template>
    <div>
        <b-toast v-model="msg.showToast" :title="title" no-auto-hide :toaster="toaster">
            <div class="body-wrapper" v-if="!isLoading">
                {{ui.message}}
                <button @click="click" :class="ui.btnClass" class="btn btn-sm">{{ui.btnMessage}}</button>
            </div>
            <b-alert
                :show="alertCountDown"
                dismissible
                variant="warning"
                @dismissed="alertCountDown=0"
                @dismiss-count-down="countDownChanged"
                >
                <p v-if="errorCRMTab">{{ $t('goto_crm_error') }}</p>
                <p v-if="errorCRMNotLoaded">{{ $t('crm_load_error') }}</p>
            </b-alert>
            <div v-if="isLoading" class="loader-wrapper">
                <i class="fas fa-spinner fa-spin fa-2x" />
            </div>
        </b-toast>
    </div>
</template>

<script>
import {EventBus} from "../event-bus.js";
import {AgentService} from "./services/agent-service";

export default {
	props: {agentService: AgentService, msg: Object, crmLoaded: Boolean},
	data: () => ({
		toaster: "toolbar_crm_intergration_toaster",
		isLoading: false,
		call: null,
		alertCountDown: 0,
		alertSecs: 5,
		errorCRMTab: false,
		errorCRMNotLoaded: false
	}),
	created() {
		if (this.msg) {
			this.isLoading = true;
			// setInterval(() => {console.info(this.agentService)}, 200);
			this.agentService.getNumberInfoFromCRM(this.msg.caller_id)
				.then(response => {
					let toastInfo = response || {number: this.msg.caller_id, unknown: true};
					this.call = toastInfo;
					this.isLoading = false;
				})
				.catch((e) => {
					console.warn("number info from crm", e);
					this.isLoading = false;
				});
		}
	},
	methods: {
		click() {
			this.errorCRMNotLoaded = false;
			this.errorCRMTab = false;
			let validLocation = /\/crm/.test(location.href);
			if (!validLocation || !this.crmLoaded) {
				if (!validLocation) {
					this.errorCRMTab = true;
				}
				else {
					this.errorCRMNotLoaded = true;
				}
				this.alertCountDown = this.alertSecs;
				return;
			}
			EventBus.$emit("crm:openmodal", {url: this.ui.clickLink});
			this.msg.showToast = false;
		},
		countDownChanged(dismissCountDown) {
			this.alertCountDown = dismissCountDown;
		}
	},
	computed: {
		title() {
			return this.$t("incomingCall_from") + this.msg.caller_id;
		},
		ui() {
			let info = this.call;
			if (!info) {
				return {};
			}
			let message = null; let btnMessage = null; let btnClass = "btn-secondary"; let clickLink = null;
			if (!info || info.unknown) {
				// cannot find
				message = this.$t("number_error");
				btnMessage = this.$t("create_at");
				clickLink = "/apps/015/Account?oid=&Mode=Modal&cls=Accounts&NewLead=true&isFromSwitchboard=true&phoneNumber=" + info.number;
				btnClass = "btn-warning";
			}
			else if (info.class == "account") {
				clickLink = "/apps/015/Account?cls=Accounts&isFromSwitchboard=true&Mode=Modal&oid=" + info.oid;
				if (info.type == "lead") {
					btnMessage = this.$t("open_at");
					message = this.$t("near_to") + ": " + info.name;
					btnClass = "btn-success";
					// title = "שיחה נכנסת";
				}
				else if (info.type == "client") {
					message = this.$t("client_title") + ": " + info.name;
					btnMessage = this.$t("open_client");
					btnClass = "btn-primary";
					// title = "שיחה נכנסת";
				}
			}
			else if (info.class == "contact") {
				message = this.$t("getCall_from") + info.name;
				// title = "שיחה נכנסת";
				btnMessage = this.$t("open_contact");
				clickLink = "/apps/015/Contact?cls=Contacts&isFromSwitchboard=true&Mode=Modal&oid=" + info.oid;
			}

			return {message, btnMessage, clickLink, btnClass};
		}
	}
};
</script>